import script from "./tenant-renewal.vue?vue&type=script&setup=true&lang=js"
export * from "./tenant-renewal.vue?vue&type=script&setup=true&lang=js"

import "./tenant-renewal.vue?vue&type=style&index=0&id=22199526&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22199526"]])

export default __exports__